// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/partner_register/organizations/firstparty/v1/list_organizations.proto

/* oxlint-disable */
import { ApiOrganization } from "../../../common/v1/organization";
import { ApiRegistration } from "../../../common/v1/registration";

/** Request message for listing organizations */
export interface ApiListOrganizationsRequest {
  /** Relationships to include in response (e.g. "registration") */
  readonly include?:
    | string
    | null
    | undefined;
  /** Filter by registration status ("pending" or "completed") */
  readonly registrationStatusEq?:
    | string
    | null
    | undefined;
  /** Filter by registration flow type ("seamless") */
  readonly registrationFlowTypeEq?: string | null | undefined;
}

/** Response message for listing organizations */
export interface ApiListOrganizationsResponse {
  /** List of organizations linked to the current user */
  readonly organizations: readonly ApiOrganization[];
  /**
   * Registration data, populated when include=registration is specified.
   * Keyed by organization.id.
   */
  readonly includedRegistrations: readonly ApiRegistration[];
}

export const ApiListOrganizationsRequest: MessageFns<ApiListOrganizationsRequest> = {
  fromJSON(object: any): ApiListOrganizationsRequest {
    return {
      include: isSet(object.include) ? globalThis.String(object.include) : null,
      registrationStatusEq: isSet(object.registrationStatusEq) ? globalThis.String(object.registrationStatusEq) : null,
      registrationFlowTypeEq: isSet(object.registrationFlowTypeEq)
        ? globalThis.String(object.registrationFlowTypeEq)
        : null,
    };
  },

  toJSON(message: ApiListOrganizationsRequest): unknown {
    const obj: any = {};
    if (message.include !== undefined && message.include !== null) {
      obj.include = message.include;
    }
    if (message.registrationStatusEq !== undefined && message.registrationStatusEq !== null) {
      obj.registrationStatusEq = message.registrationStatusEq;
    }
    if (message.registrationFlowTypeEq !== undefined && message.registrationFlowTypeEq !== null) {
      obj.registrationFlowTypeEq = message.registrationFlowTypeEq;
    }
    return obj;
  },
};

export const ApiListOrganizationsResponse: MessageFns<ApiListOrganizationsResponse> = {
  fromJSON(object: any): ApiListOrganizationsResponse {
    return {
      organizations: globalThis.Array.isArray(object?.organizations)
        ? object.organizations.map((e: any) => ApiOrganization.fromJSON(e))
        : [],
      includedRegistrations: globalThis.Array.isArray(object?.includedRegistrations)
        ? object.includedRegistrations.map((e: any) => ApiRegistration.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiListOrganizationsResponse): unknown {
    const obj: any = {};
    if (message.organizations?.length) {
      obj.organizations = message.organizations.map((e) => ApiOrganization.toJSON(e));
    }
    if (message.includedRegistrations?.length) {
      obj.includedRegistrations = message.includedRegistrations.map((e) => ApiRegistration.toJSON(e));
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
